import { render, staticRenderFns } from "./ManageFooterBar.vue?vue&type=template&id=c50c0414&scoped=true&"
import script from "./ManageFooterBar.vue?vue&type=script&lang=js&"
export * from "./ManageFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./ManageFooterBar.vue?vue&type=style&index=0&id=c50c0414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50c0414",
  null
  
)

export default component.exports